/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({}, payload) {
    const url = `/dashboard?${queryString(payload.params)}`;
    const { data, headers } = await http.get(url).then((data) => data);
    return { data: data.data, headers };
  },

  async fetchMentawai({}, payload) {
    const url = `/dashboard/mentawai?${queryString(payload.params)}`;
    const { data, headers } = await http.get(url).then((data) => data);
    return { data: data.data || data, headers };
  },

  async fetchMentawaiRekap({}, payload) {
    const url = `/dashboard/${payload.endpoint}?${queryString(payload.params)}`;
    const { data, headers } = await http.get(url).then((data) => data);
    const body =
      data.data && data.meta === undefined && (data.data.data || data.data.current_page !== undefined)
        ? data.data
        : data;
    const paginationMeta =
      body && (body.current_page !== undefined || body.last_page !== undefined || body.total !== undefined)
        ? body
        : body.meta;

    return {
      data: body.data || body,
      meta: paginationMeta,
      links: body.links,
      headers,
    };
  },

  async fetchPemandu({}, payload) {
    const url = `/pemandu/rekaps?${queryString(payload.params)}`;
    const { data, headers } = await http.get(url).then((data) => data);
    return { data: data.data, headers };
  },

  async fetchMitra({}, payload) {
    const url = `/mitra/rekaps?${queryString(payload.params)}`;
    const { data, headers } = await http.get(url).then((data) => data);
    return { data: data.data, headers };
  },
};
